angular
  .module('goodsList')
  .component('goodsList', {
    template: require('./goods-list.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function _($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'goods';

        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.durations = Array(101).fill().map((x, i) => i * 5);

        // Display labels for product menu (DB TYPE unchanged)
        this.displayType = (type) => {
          if (!type) return '';
          const map = {
            silver: 'Ex',
            gold: 'Pro',
            platinum: 'Ultra',
            pearl: 'Pure',
          };
          const key = String(type).toLowerCase();
          return map[key] || String(type).toUpperCase();
        };

        $resource(`${APIURL}/admin/goods/types`).get({}, (data) => {
          this.goodsTypes = data.goodsTypes.map((goodsType, index) => {
            goodsType.KEY = index;
            return goodsType;
          });
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });

        $resource(`${APIURL}/admin/meta/subscription/add `).get().$promise
          .then((data) => {
            this.meta = data;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });

        this.addGood = (good) => {
          $resource(`${APIURL}/admin/goods/types/${good.TYPE}`).save(this.newGood, (data) => {
            alert($translate.instant('추가되었습니다.'));
            good.data = data;
            this.newGood = {};
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.modifyPrices = (targetGoods) => {
          this.targetModifyPriceGoods = $.extend({}, targetGoods); // eslint-disable-line
          this.targetModifyPriceGoodsOriginal = targetGoods;
          this.targetModifyPriceGoods.DURATION = this.targetModifyPriceGoods.DURATION.toString();
          jQuery('#modal-modifyPrice').modal('show');
        };
        this.submitModifyPrices = () => {
          if (this.targetModifyPriceGoods.DURATION === undefined) {
            alert($translate.instant('세차 시간을 선택해주세요.'));
            return;
          }
          if (this.targetModifyPriceGoods.DURATION_TXT.length < 1) {
            alert($translate.instant('세차 시간 표기를 입력해주세요.'));
            return;
          }
          if (this.targetModifyPriceGoods.GOODS_PRICE === undefined) {
            alert($translate.instant('세차 가격을 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.targetModifyPriceGoods.GOODS_PRICE, 10)) === true || parseInt(this.targetModifyPriceGoods.GOODS_PRICE, 10) < 0) {
            alert($translate.instant('올바른 세차 가격을 입력해주세요.'));
            return;
          }
          if (this.targetModifyPriceGoods.PRICE === undefined) {
            alert($translate.instant('세차 가격을 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.targetModifyPriceGoods.PRICE, 10)) === true || parseInt(this.targetModifyPriceGoods.PRICE, 10) < 0) {
            alert($translate.instant('올바른 세차 가격을 입력해주세요.'));
            return;
          }
          if (this.targetModifyPriceGoods.EMPLOYEE_PRICE === undefined) {
            alert($translate.instant('정산을 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.targetModifyPriceGoods.EMPLOYEE_PRICE, 10)) === true || parseInt(this.targetModifyPriceGoods.EMPLOYEE_PRICE, 10) < 0) {
            alert($translate.instant('올바른 정산 가격을 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/goods/${this.targetModifyPriceGoods.ID}`).save(this.targetModifyPriceGoods, () => {
            alert($translate.instant('수정되었습니다.'));
            this.targetModifyPriceGoodsOriginal.DURATION = this.targetModifyPriceGoods.DURATION;
            this.targetModifyPriceGoodsOriginal.DURATION_TXT = this.targetModifyPriceGoods.DURATION_TXT;
            this.targetModifyPriceGoodsOriginal.PRICE = this.targetModifyPriceGoods.PRICE;
            this.targetModifyPriceGoodsOriginal.GOODS_PRICE = this.targetModifyPriceGoods.GOODS_PRICE;
            this.targetModifyPriceGoodsOriginal.EMPLOYEE_PRICE = this.targetModifyPriceGoods.EMPLOYEE_PRICE;
            jQuery('#modal-modifyPrice').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.modifyText = (targetGood, title, subtitle, text, targetText) => {
          this.text = { targetGood, title, subtitle, text, targetText };
          jQuery('#modal-modifyText').modal('show');
        };
        this.submitModifyText = () => {
          $resource(`${APIURL}/admin/goods/types/${this.text.targetGood.TYPE}/${this.text.targetText}`).save({ TEXT: this.text.text }, (data) => {
            alert($translate.instant('수정되었습니다.'));
            this.text.targetGood.data = data;
            jQuery('#modal-modifyText').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.modifyImages = (targetGoods) => {
          this.targetModifyImageGoods = $.extend({}, targetGoods); // eslint-disable-line
          console.log(targetGoods.data.good);
          jQuery('#modal-modifyImage').modal('show');
        };

        this.modifyImagesRemoveAt = (url) => {
          const URLS = [];
          if (this.targetModifyImageGoods.data.good.URLS) {
            this.targetModifyImageGoods.data.good.URLS.forEach((item) => {
              if (item !== url) {
                URLS.push(item);
              }
            });
          }
          this.targetModifyImageGoods.data.good.URLS = URLS;
        };

        this.modifyImagesNewImage = () => {
          this.targetModifyImageGoods.data.good.URLS.push('');
        };

        this.modifyImagesUploadImage = (media, files, index) => {
          console.log('modifyImagesUploadImage');
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${APIURL}/admin/file/options`,
              file,
            }).progress(() => {
            }).success((data, status, headers, config) => { // eslint-disable-line no-unused-vars
              console.log(data.url);
              this.targetModifyImageGoods.data.good.URLS[index] = data.url;
            });
          }
        };

        this.submitModifyImages = () => {
          $resource(`${APIURL}/admin/goods/types/${this.targetModifyImageGoods.TYPE}/images`).save({ URL: this.targetModifyImageGoods.data.good.URLS }, (data) => {
            alert($translate.instant('수정되었습니다.'));
            this.targetModifyImageGoods.data = data;
            jQuery('#modal-modifyImage').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.deleteGood = (good, targetGood) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/goods/${targetGood.ID}`).delete({},
            () => {
              alert($translate.instant('삭제되었습니다'));
              const goods = good.data.goods;
              goods.splice(goods.indexOf(targetGood), 1);
              if (goods.length < 1) {
                this.goodsTypes = this.goodsTypes.filter(type => type !== good);
              }
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.loadDataIfNeeded = (good) => {
          if (good.data) {
            return;
          }

          $resource(`${APIURL}/admin/goods/types/:type`).get({ type: good.TYPE }, (data) => {
            good.data = data;
            console.log(data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/goods-list/goods-list.component.js